export default __webpack_public_path__ + "static/media/April2025.1f712bd7.svg";